/** Where a CMS-listed order came from (backend `CmsOrderSource`). */
export type OrderSource = 'marketplace' | 'classic';

export const ORDER_SOURCES: OrderSource[] = ['marketplace', 'classic'];

export const ORDER_SOURCE_META: Record<OrderSource, { label: string; colorScheme: string; description: string }> = {
  marketplace: { label: 'Marketplace', colorScheme: 'purple', description: 'Placed from the GPO Marketplace' },
  classic: { label: 'Classic', colorScheme: 'gray', description: 'A direct order to the supplier' },
};

/** An unknown or missing value (an older backend) reads as no source rather than breaking the row. */
export const orderSourceMeta = (source: unknown) =>
  typeof source === 'string' && source in ORDER_SOURCE_META ? ORDER_SOURCE_META[source as OrderSource] : null;
